import { defineMessages } from 'react-intl';

export const youtubeBroadcastsListMessages = defineMessages({
  pageTitle: {
    id: 'logger.youtubeBroadcasts.pageTitle',
    defaultMessage: 'Transmisiones de YouTube',
  },
  noYoutubeNativeStations: {
    id: 'logger.youtubeBroadcasts.noYoutubeNativeStations',
    defaultMessage: 'No hay emisoras con integración YouTube Native',
  },
});
